const ERROR_REPORTER = window.ERROR_REPORTER;

const MESSAGE_TYPE_ERROR = window.MESSAGE_TYPE_ERROR;
const MESSAGE_TYPE_SUCCESS = window.MESSAGE_TYPE_SUCCESS;
const MESSAGE_TYPE_WARNING = window.MESSAGE_TYPE_WARNING;
const MESSAGE_TYPE_INFO = window.MESSAGE_TYPE_INFO;

export default {
	
	install (Vue) {
		
		Vue.prototype.$hideMessage = () => {
			ERROR_REPORTER.hideMessage()
		}
		
		Vue.prototype.$showError = (message, woDelay, woTimeout) => {
			ERROR_REPORTER.showMessage(message, MESSAGE_TYPE_ERROR, woDelay, woTimeout)
		}
		
		Vue.prototype.$showSuccess = (message, woDelay, woTimeout) => {
			ERROR_REPORTER.showMessage(message, MESSAGE_TYPE_SUCCESS, woDelay, woTimeout)
		}
		
		Vue.prototype.$showWarning = (message, woDelay, woTimeout) => {
			ERROR_REPORTER.showMessage(message, MESSAGE_TYPE_WARNING, woDelay, woTimeout)
		}
		
		Vue.prototype.$showInfo = (message, woDelay, woTimeout) => {
			ERROR_REPORTER.showMessage(message, MESSAGE_TYPE_INFO, woDelay, woTimeout)
		}
	}
}